import sanitizeHtml from 'sanitize-html';

import { getAbsoluteMediaUrl } from '@umbraco/Utils/GetAbsoluteMediaUrl';

export const SANITISE_SETTINGS = {
  allowedTags: [...sanitizeHtml.defaults.allowedTags, 'img'],
  allowedAttributes: {
    //sanitize-html default
    a: ['href', 'name', 'target'],
    img: ['src', 'srcset', 'alt', 'title', 'width', 'height', 'loading'],
    //DRIVE additions
    h1: ['id'],
    h2: ['id'],
    h3: ['id'],
    h4: ['id'],
    h5: ['id'],
    h6: ['id'],
    div: ['id'],
  },
  transformTags: {
    img: (tagName: string, attribs: Record<string, string>) => ({
      tagName,
      attribs: {
        ...attribs,
        ...(attribs.src && { src: getAbsoluteMediaUrl(attribs.src) }),
      },
    }),
  },
};
